// --------------------------------------------------------
//
// THIS FILE PROVIDES THE CONFIGURATION FOR AUTHENTICATION
//
// --------------------------------------------------------


module.exports = Object.freeze({

   // --- POLICIES ---
   // Enter here the user flows and custom policies for your B2C application
   // To learn more about user flows, visit https://docs.microsoft.com/en-us/azure/active-directory-b2c/user-flow-overview
   // To learn more about custom policies, visit https://docs.microsoft.com/en-us/azure/active-directory-b2c/custom-policy-overview
   b2cPolicies : {
      names: {
         signUpSignIn: process.env.VUE_APP_B2C_POL_SISU_NAME,
         forgotPassword: process.env.VUE_APP_B2C_POL_FPWD_NAME,
         editProfile: process.env.VUE_APP_B2C_POL_PROF_NAME
      },
      authorities: {
         signUpSignIn: {
            authority: process.env.VUE_APP_B2C_POL_SISU_AUTH,
         },
         forgotPassword: {
            authority: process.env.VUE_APP_B2C_POL_FPWD_AUTH,
            redirectStartPage: process.env.VUE_APP_B2C_REDIRECT_URL
         },
         editProfile: {
            authority: process.env.VUE_APP_B2C_POL_PROF_AUTH,
            redirectStartPage: process.env.VUE_APP_B2C_REDIRECT_URL
         }
      },
   },

   // --- API CONFIG ---
   // The current application coordinates were pre-registered in a B2C tenant.
   apiConfig : {
      b2cScopes: [
         process.env.VUE_APP_B2C_APISCOPE_READ, 
         process.env.VUE_APP_B2C_APISCOPE_WRITE
      ],
      webApi: process.env.VUE_APP_BASE_API_URL
   },

   // --- AUTH CONFIG ---
   /**
   * Config object to be passed to MSAL on creation.
   * For a full list of msal.js configuration parameters, 
   * visit https://azuread.github.io/microsoft-authentication-library-for-js/docs/msal/modules/_configuration_.html
   * NOTE:validateAuthority should always be false for B2C
   * */
   msalConfig : {
      auth: {
         clientId: process.env.VUE_APP_B2C_CLIENT_ID,
         authorityDomain: process.env.VUE_APP_B2C_AUTHORITY,
         authority: process.env.VUE_APP_B2C_POL_SISU_AUTH,
         knownAuthorities: [
            process.env.VUE_APP_B2C_AUTHORITY,
            process.env.VUE_APP_B2C_POL_SISU_AUTH,
            process.env.VUE_APP_B2C_POL_FPWD_AUTH,
            process.env.VUE_APP_B2C_POL_PROF_AUTH
         ],
         redirectUri: process.env.VUE_APP_B2C_REDIRECT_URL,
         validateAuthority: false
      },
      cache: {
         cacheLocation: "localStorage", // This configures where your cache will be stored
         storeAuthStateInCookie: false // Set this to "true" to save cache in cookies to address trusted zones limitations in IE (see: https://github.com/AzureAD/microsoft-authentication-library-for-js/wiki/Known-issues-on-IE-and-Edge-Browser)
      }
   },

   /** 
   * Scopes you enter here will be consented once you authenticate. For a full list of available authentication parameters, 
   * visit https://azuread.github.io/microsoft-authentication-library-for-js/docs/msal/modules/_authenticationparameters_.html
   */
   loginRequest : {
      scopes: [
         "openid", 
         "profile", 
         process.env.VUE_APP_B2C_APISCOPE_READ, 
         process.env.VUE_APP_B2C_APISCOPE_WRITE
      ],
      redirectUri: process.env.VUE_APP_B2C_REDIRECT_URL
   },

   // Add here scopes for access token to be used at the API endpoints.
   tokenRequest : {
      scopes: [
         "openid", 
         "profile", 
         process.env.VUE_APP_B2C_APISCOPE_READ, 
         process.env.VUE_APP_B2C_APISCOPE_WRITE
      ],  // e.g. ["https://fabrikamb2c.onmicrosoft.com/helloapi/demo.read"]
      forceRefresh: false 
   }

})